<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-home-goods">
    <header class="ren-decoration-cp-scenic-home-goods__head">
      <strong>{{ title }}</strong>
    </header>
    <p v-if="items.length === 0" class="ren-decoration-cp-scenic-home-goods__empty">暂无团购票种</p>
    <article
      v-for="(item, index) in items"
      :key="`${item.name}-${index}`"
      class="ren-decoration-cp-scenic-home-goods__item">
      <div class="ren-decoration-cp-scenic-home-goods__cover" aria-hidden="true">{{ coverGlyph(item.name) }}</div>
      <div class="ren-decoration-cp-scenic-home-goods__body">
        <b class="ren-decoration-cp-scenic-home-goods__name">{{ item.name }}</b>
        <div class="ren-decoration-cp-scenic-home-goods__sub">
          <span v-if="item.tags.length" class="ren-decoration-cp-scenic-home-goods__tags">
            <i v-for="(tag, tagIndex) in item.tags" :key="`${tag}-${tagIndex}`">{{ tag }}</i>
          </span>
          <span class="ren-decoration-cp-scenic-home-goods__price">{{ scenicYuan(item.priceCents) }}</span>
        </div>
        <div v-if="showSales" class="ren-decoration-cp-scenic-home-goods__sales">
          已售 {{ item.sales }}
        </div>
      </div>
      <button type="button" class="ren-decoration-cp-scenic-home-goods__buy">{{ buyText }}</button>
    </article>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { booleanValue, numberValue, stringValue } from '../../../previews/preview-helpers'
import { SAMPLE_GOODS, scenicYuan } from '../../scenic-preview-data'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const title = computed(() => stringValue(props.component.props?.title, '超值团购'))
const buyText = computed(() => stringValue(props.component.props?.buyText, '抢购'))
const showSales = computed(() => booleanValue(props.component.props?.showSales, true))
const limit = computed(() => {
  const value = Math.round(numberValue(props.component.props?.limit, 3))
  return Number.isFinite(value) ? Math.min(20, Math.max(1, value)) : 3
})
const items = computed(() => SAMPLE_GOODS.slice(0, limit.value))

function coverGlyph(name: string) {
  return (name || '票').trim().slice(0, 1)
}
</script>

<style scoped>
.ren-decoration-cp-scenic-home-goods {
  display: grid;
  gap: 10px;
  padding: 12px;
  background: var(--ren-theme-card);
}
.ren-decoration-cp-scenic-home-goods__head strong {
  color: var(--ren-theme-text);
  font-size: 14px;
}
.ren-decoration-cp-scenic-home-goods__empty {
  margin: 0;
  color: var(--ren-theme-muted);
  font-size: 12px;
}
.ren-decoration-cp-scenic-home-goods__item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ren-decoration-cp-scenic-home-goods__cover {
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  border-radius: var(--ren-theme-radius);
  color: #fff;
  background: linear-gradient(135deg, var(--ren-theme-primary), var(--ren-theme-accent));
  font-size: 18px;
}
.ren-decoration-cp-scenic-home-goods__body {
  flex: 1;
  min-width: 0;
  display: grid;
  gap: 4px;
}
.ren-decoration-cp-scenic-home-goods__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--ren-theme-text);
  font-size: 13px;
}
.ren-decoration-cp-scenic-home-goods__sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.ren-decoration-cp-scenic-home-goods__tags {
  display: flex;
  gap: 4px;
  min-width: 0;
}
.ren-decoration-cp-scenic-home-goods__tags i {
  font-style: normal;
  padding: 1px 5px;
  border: 1px solid var(--ren-theme-border);
  border-radius: 4px;
  color: var(--ren-theme-muted);
  font-size: 10px;
}
.ren-decoration-cp-scenic-home-goods__price {
  color: var(--ren-theme-accent);
  font-size: 13px;
  font-weight: 600;
}
.ren-decoration-cp-scenic-home-goods__sales {
  color: var(--ren-theme-muted);
  font-size: 11px;
}
.ren-decoration-cp-scenic-home-goods__buy {
  flex: 0 0 auto;
  border: 0;
  border-radius: 999px;
  padding: 5px 12px;
  background: linear-gradient(135deg, var(--ren-theme-primary), var(--ren-theme-accent));
  color: #fff;
  font-size: 12px;
}
</style>
